module.exports = {
	"ha": "vcha",
	"id": 5.5,
	"report": {
		"ha": "Vancouver Coastal Health",
		"group": "HSDA",
		"period": "2017 Q2–2019 Q1",
		"lastYear": "2019",
		"lastQuarter": "1"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 950,
			"height": 530,
			"marginTop": 80,
			"marginLeft": 110,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "column"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1,
			"valueSuffix": " %"
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 110px;\">Figure 5.5</span>                 <span style=\"display: table-cell;\">Estimated Cascade of Care for Vancouver Coastal Health by Age Category and MSM Status, Year Ending 2019 Q1 <sup style=\"font-size: 10px;\">9</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {},
					"verticalAlign": "top"
				},
				"pointPadding": 0,
				"groupPadding": 0,
				"stacking": "normal",
				"colorByPoint": true
			},
			"column": {
				"colors": [
					"",
					"#043f61",
					"#0c4250",
					"#0d4440",
					"#09472e",
					"#0a4a23"
				]
			}
		},
		"xAxis": [
			{
				"lineWidth": 0,
				"tickWidth": 0,
				"labels": {
					"reserveSpace": false,
					"rotation": 270,
					"y": -100,
					"align": "left",
					"style": {
						"fontSize": "1.2em",
						"color": "white",
						"textOutline": "0.5px contrast"
					}
				},
				"categories": [
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					""
				]
			}
		],
		"yAxis": [
			{
				"height": "60%",
				"max": 100,
				"tickPosition": "inside",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#231f20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"title": {
					"text": "% of Diagnosed",
					"margin": -10,
					"x": -30
				},
				"labels": {
					"format": "{value}%"
				},
				"plotLines": [
					{
						"value": 0,
						"color": "black",
						"dashStyle": "solid",
						"width": 1,
						"zIndex": 100
					}
				]
			},
			{
				"top": "60%",
				"height": "40%",
				"tickPosition": "inside",
				"lineColor": "#9e1c20",
				"lineWidth": 1,
				"tickColor": "#9e1c20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#9e1c20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"max": 0,
				"min": -60,
				"title": {
					"text": "% Loss from<br>Previous Stage",
					"margin": -10,
					"style": {
						"color": "#9e1c20"
					},
					"x": -30
				},
				"labels": {
					"format": "{value}%",
					"style": {
						"color": "#9e1c20"
					},
					"zIndex": 1
				}
			}
		],
		"series": [
			{
				"name": "% of Diagnosed",
				"yAxis": 0,
				"data": [
					{
						"y": null
					},
					{
						"y": 94.9367088607595,
						"dataLabels": {
							"enabled": false,
							"format": "75"
						},
						"color": "#043f61"
					},
					{
						"y": 88.60759493670885,
						"dataLabels": {
							"enabled": false,
							"format": "70"
						},
						"color": "#0c4250"
					},
					{
						"y": 84.81012658227847,
						"dataLabels": {
							"enabled": false,
							"format": "67"
						},
						"color": "#0d4440"
					},
					{
						"y": 70.88607594936708,
						"dataLabels": {
							"enabled": false,
							"format": "56"
						},
						"color": "#09472e"
					},
					{
						"y": 64.55696202531645,
						"dataLabels": {
							"enabled": false,
							"format": "51"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 95.32710280373831,
						"dataLabels": {
							"enabled": false,
							"format": "306"
						},
						"color": "#043f61"
					},
					{
						"y": 81.93146417445483,
						"dataLabels": {
							"enabled": false,
							"format": "263"
						},
						"color": "#0c4250"
					},
					{
						"y": 79.12772585669782,
						"dataLabels": {
							"enabled": false,
							"format": "254"
						},
						"color": "#0d4440"
					},
					{
						"y": 71.02803738317756,
						"dataLabels": {
							"enabled": false,
							"format": "228"
						},
						"color": "#09472e"
					},
					{
						"y": 64.48598130841121,
						"dataLabels": {
							"enabled": false,
							"format": "207"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 97.57869249394673,
						"dataLabels": {
							"enabled": false,
							"format": "403"
						},
						"color": "#043f61"
					},
					{
						"y": 89.10411622276028,
						"dataLabels": {
							"enabled": false,
							"format": "368"
						},
						"color": "#0c4250"
					},
					{
						"y": 84.50363196125909,
						"dataLabels": {
							"enabled": false,
							"format": "349"
						},
						"color": "#0d4440"
					},
					{
						"y": 79.90314769975787,
						"dataLabels": {
							"enabled": false,
							"format": "330"
						},
						"color": "#09472e"
					},
					{
						"y": 70.46004842615012,
						"dataLabels": {
							"enabled": false,
							"format": "291"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 99.7254632807138,
						"dataLabels": {
							"enabled": false,
							"format": "1453"
						},
						"color": "#043f61"
					},
					{
						"y": 92.03843514070007,
						"dataLabels": {
							"enabled": false,
							"format": "1341"
						},
						"color": "#0c4250"
					},
					{
						"y": 88.94989704873026,
						"dataLabels": {
							"enabled": false,
							"format": "1296"
						},
						"color": "#0d4440"
					},
					{
						"y": 85.17501715854495,
						"dataLabels": {
							"enabled": false,
							"format": "1241"
						},
						"color": "#09472e"
					},
					{
						"y": 77.62525737817433,
						"dataLabels": {
							"enabled": false,
							"format": "1131"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": null
					},
					{
						"y": 100,
						"dataLabels": {
							"enabled": false,
							"format": "20"
						},
						"color": "#043f61"
					},
					{
						"y": 95,
						"dataLabels": {
							"enabled": false,
							"format": "19"
						},
						"color": "#0c4250"
					},
					{
						"y": 90,
						"dataLabels": {
							"enabled": false,
							"format": "18"
						},
						"color": "#0d4440"
					},
					{
						"y": 65,
						"dataLabels": {
							"enabled": false,
							"format": "13"
						},
						"color": "#09472e"
					},
					{
						"y": 50,
						"dataLabels": {
							"enabled": false,
							"format": "10"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 98.01324503311258,
						"dataLabels": {
							"enabled": false,
							"format": "148"
						},
						"color": "#043f61"
					},
					{
						"y": 92.05298013245033,
						"dataLabels": {
							"enabled": false,
							"format": "139"
						},
						"color": "#0c4250"
					},
					{
						"y": 85.43046357615894,
						"dataLabels": {
							"enabled": false,
							"format": "129"
						},
						"color": "#0d4440"
					},
					{
						"y": 70.86092715231787,
						"dataLabels": {
							"enabled": false,
							"format": "107"
						},
						"color": "#09472e"
					},
					{
						"y": 54.3046357615894,
						"dataLabels": {
							"enabled": false,
							"format": "82"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 98.67986798679867,
						"dataLabels": {
							"enabled": false,
							"format": "299"
						},
						"color": "#043f61"
					},
					{
						"y": 91.0891089108911,
						"dataLabels": {
							"enabled": false,
							"format": "276"
						},
						"color": "#0c4250"
					},
					{
						"y": 86.79867986798679,
						"dataLabels": {
							"enabled": false,
							"format": "263"
						},
						"color": "#0d4440"
					},
					{
						"y": 75.24752475247524,
						"dataLabels": {
							"enabled": false,
							"format": "228"
						},
						"color": "#09472e"
					},
					{
						"y": 56.10561056105611,
						"dataLabels": {
							"enabled": false,
							"format": "170"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 99.0450204638472,
						"dataLabels": {
							"enabled": false,
							"format": "726"
						},
						"color": "#043f61"
					},
					{
						"y": 94.6793997271487,
						"dataLabels": {
							"enabled": false,
							"format": "694"
						},
						"color": "#0c4250"
					},
					{
						"y": 90.17735334242838,
						"dataLabels": {
							"enabled": false,
							"format": "661"
						},
						"color": "#0d4440"
					},
					{
						"y": 83.4924965893588,
						"dataLabels": {
							"enabled": false,
							"format": "612"
						},
						"color": "#09472e"
					},
					{
						"y": 66.9849931787176,
						"dataLabels": {
							"enabled": false,
							"format": "491"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": null
					},
					{
						"y": 44,
						"dataLabels": {
							"enabled": false,
							"format": "44"
						},
						"color": "#043f61"
					},
					{
						"y": 35,
						"dataLabels": {
							"enabled": false,
							"format": "35"
						},
						"color": "#0c4250"
					},
					{
						"y": 34,
						"dataLabels": {
							"enabled": false,
							"format": "34"
						},
						"color": "#0d4440"
					},
					{
						"y": 28.999999999999996,
						"dataLabels": {
							"enabled": false,
							"format": "29"
						},
						"color": "#09472e"
					},
					{
						"y": 23,
						"dataLabels": {
							"enabled": false,
							"format": "23"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 96.4824120603015,
						"dataLabels": {
							"enabled": false,
							"format": "192"
						},
						"color": "#043f61"
					},
					{
						"y": 78.89447236180904,
						"dataLabels": {
							"enabled": false,
							"format": "157"
						},
						"color": "#0c4250"
					},
					{
						"y": 76.38190954773869,
						"dataLabels": {
							"enabled": false,
							"format": "152"
						},
						"color": "#0d4440"
					},
					{
						"y": 72.36180904522614,
						"dataLabels": {
							"enabled": false,
							"format": "144"
						},
						"color": "#09472e"
					},
					{
						"y": 64.321608040201,
						"dataLabels": {
							"enabled": false,
							"format": "128"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 94.18960244648318,
						"dataLabels": {
							"enabled": false,
							"format": "308"
						},
						"color": "#043f61"
					},
					{
						"y": 74.00611620795107,
						"dataLabels": {
							"enabled": false,
							"format": "242"
						},
						"color": "#0c4250"
					},
					{
						"y": 71.86544342507645,
						"dataLabels": {
							"enabled": false,
							"format": "235"
						},
						"color": "#0d4440"
					},
					{
						"y": 67.58409785932722,
						"dataLabels": {
							"enabled": false,
							"format": "221"
						},
						"color": "#09472e"
					},
					{
						"y": 61.16207951070336,
						"dataLabels": {
							"enabled": false,
							"format": "200"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 96.03072983354673,
						"dataLabels": {
							"enabled": false,
							"format": "750"
						},
						"color": "#043f61"
					},
					{
						"y": 71.83098591549296,
						"dataLabels": {
							"enabled": false,
							"format": "561"
						},
						"color": "#0c4250"
					},
					{
						"y": 69.52624839948783,
						"dataLabels": {
							"enabled": false,
							"format": "543"
						},
						"color": "#0d4440"
					},
					{
						"y": 65.94110115236876,
						"dataLabels": {
							"enabled": false,
							"format": "515"
						},
						"color": "#09472e"
					},
					{
						"y": 60.179257362355955,
						"dataLabels": {
							"enabled": false,
							"format": "470"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "% Loss from Previous Stage",
				"yAxis": 1,
				"data": [
					{
						"y": null
					},
					{
						"y": -5.063291139240511,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -6.666666666666665,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -4.285714285714281,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -16.417910447761198,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -8.92857142857143,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -4.672897196261683,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -14.052287581699341,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -3.4220532319391594,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -10.236220472440948,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -9.210526315789469,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -2.421307506053272,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -8.684863523573206,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -5.163043478260865,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -5.444126074498568,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -11.818181818181817,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -0.27453671928620027,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -7.708189951823807,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -3.3557046979865723,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -4.243827160493829,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -8.863819500402903,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": null
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -5.000000000000004,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -5.263157894736848,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -27.77777777777778,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -23.076923076923073,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -1.9867549668874163,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -6.081081081081086,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -7.194244604316546,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -17.05426356589147,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -23.364485981308412,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -1.320132013201325,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -7.692307692307687,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -4.710144927536231,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -13.307984790874528,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -25.438596491228072,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -0.9549795361528002,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -4.40771349862259,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -4.7550432276657,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -7.413010590015123,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -19.771241830065357,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": null
					},
					{
						"y": -56.00000000000001,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -20.45454545454546,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -2.857142857142858,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -14.70588235294118,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -20.68965517241379,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -3.5175879396984966,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -18.229166666666664,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -3.1847133757961776,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -5.263157894736848,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -11.111111111111116,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -5.810397553516822,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -21.42857142857143,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -2.892561983471076,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -5.957446808510635,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -9.502262443438914,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -3.969270166453265,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -25.2,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -3.208556149732622,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -5.156537753222834,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -8.737864077669899,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			}
		],
		"groups": [
			{
				"x": 12,
				"y": 40,
				"text": "MSM"
			},
			{
				"x": 3,
				"text": "<30<br>n=79"
			},
			{
				"x": 9,
				"text": "30-39<br>n=321"
			},
			{
				"x": 15,
				"text": "40-49<br>n=413"
			},
			{
				"x": 21,
				"text": ">=50<br>n=1457"
			},
			{
				"x": 37,
				"y": 40,
				"text": "Non-MSM"
			},
			{
				"x": 28,
				"text": "<30<br>n=20"
			},
			{
				"x": 34,
				"text": "30-39<br>n=151"
			},
			{
				"x": 40,
				"text": "40-49<br>n=303"
			},
			{
				"x": 46,
				"text": ">=50<br>n=733"
			},
			{
				"x": 62,
				"y": 40,
				"text": "Unknown"
			},
			{
				"x": 53,
				"text": "<30<br>n=100"
			},
			{
				"x": 59,
				"text": "30-39<br>n=199"
			},
			{
				"x": 65,
				"text": "40-49<br>n=327"
			},
			{
				"x": 71,
				"text": ">=50<br>n=781"
			}
		],
		"dataTable": {
			"MSM:<30": [
				79,
				75,
				70,
				67,
				56,
				51
			],
			"MSM:30-39": [
				321,
				306,
				263,
				254,
				228,
				207
			],
			"MSM:40-49": [
				413,
				403,
				368,
				349,
				330,
				291
			],
			"MSM:>=50": [
				1457,
				1453,
				1341,
				1296,
				1241,
				1131
			],
			"Non-MSM:<30": [
				20,
				20,
				19,
				18,
				13,
				10
			],
			"Non-MSM:30-39": [
				151,
				148,
				139,
				129,
				107,
				82
			],
			"Non-MSM:40-49": [
				303,
				299,
				276,
				263,
				228,
				170
			],
			"Non-MSM:>=50": [
				733,
				726,
				694,
				661,
				612,
				491
			],
			"Unknown:<30": [
				100,
				44,
				35,
				34,
				29,
				23
			],
			"Unknown:30-39": [
				199,
				192,
				157,
				152,
				144,
				128
			],
			"Unknown:40-49": [
				327,
				308,
				242,
				235,
				221,
				200
			],
			"Unknown:>=50": [
				781,
				750,
				561,
				543,
				515,
				470
			]
		}
	},
	"callback": "C:\\Users\\Nada\\Documents\\GitHub\\qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_vcha_5_5.png"
};


//////////////////
// WEBPACK FOOTER
// ./temp/json/figure_vcha_5_5.json
// module id = 306
// module chunks = 0